import { render, staticRenderFns } from "./ScheduledSettings.vue?vue&type=template&id=1c24981d&"
import script from "./ScheduledSettings.vue?vue&type=script&lang=js&"
export * from "./ScheduledSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports